export const formatTime = (timeValue) => {
    if (timeValue === null || timeValue === undefined || timeValue === '') {
        return "0 hrs";
    }
    const hours = Math.floor(timeValue);
    const minutes = (timeValue % 1) * 60;
    if (hours === 0) {
        return `${minutes} min`;
    } else if (hours !== 0 && minutes > 0) {
        return `${hours} hrs ${minutes} min`
    } else {
        return `${hours} hrs`;
    }
}